/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPayersForCustomer} from '../api'

 export const useQueryGetPayersForCustomer = createReactQueryHook('getPayersForCustomer', getPayersForCustomer)
